import React from 'react';
import MobileContentSimulator from '../components/mobile-simulator/MobileContentSimulator';

const MobileSimulatorPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Mobile Content Simulator</h1>
      <div className="bg-white rounded-lg shadow-xl p-6">
        <MobileContentSimulator />
      </div>
    </div>
  );
};

export default MobileSimulatorPage;
